export default "__VITE_ASSET__CVlPvR5U__"